var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletterElement2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.128,
    height: 124.282,
    viewBox: "0 0 155.128 124.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "element-2",
    transform: "translate(23062.639 8737.519) rotate(-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5609",
    "data-name": "Pfad 5609",
    d: "M61.4,65.366A29.892,29.892,0,1,0,31.507,35.475,29.891,29.891,0,0,0,61.4,65.366",
    transform: "translate(-18837.242 -15639.66) rotate(180)",
    fill: "#052971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5614",
    "data-name": "Pfad 5614",
    d: "M69.525,41.977A15.843,15.843,0,1,0,53.682,26.133,15.842,15.842,0,0,0,69.525,41.977",
    transform: "translate(-18891.078 -15651.094) rotate(180)",
    fill: "#6a82c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5617",
    "data-name": "Pfad 5617",
    d: "M37.861,44.445a8.967,8.967,0,1,1,8.967-8.967,8.969,8.969,0,0,1-8.967,8.967",
    transform: "translate(-18830.891 -15690.478) rotate(180)",
    fill: "#6a82c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3342",
    "data-name": "Rechteck 3342",
    width: 17.938,
    height: 17.934,
    transform: "translate(-18859.781 -15716.988) rotate(180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5639",
    "data-name": "Pfad 5639",
    d: "M72.495,25.06a8.967,8.967,0,1,1,8.967-8.967,8.969,8.969,0,0,1-8.967,8.967",
    transform: "translate(-18914.977 -15643.409) rotate(180)",
    fill: "#e23e4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3347",
    "data-name": "Rechteck 3347",
    width: 17.938,
    height: 17.934,
    transform: "translate(-18978.5 -15650.535) rotate(180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5642",
    "data-name": "Pfad 5642",
    d: "M30.4,28.751a8.969,8.969,0,1,1,8.967-8.967A8.966,8.966,0,0,1,30.4,28.751",
    transform: "translate(-18812.771 -15652.354) rotate(180)",
    fill: "#e23e4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3349",
    "data-name": "Rechteck 3349",
    width: 17.934,
    height: 17.938,
    transform: "translate(-18834.199 -15663.168) rotate(180)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterElement2);
export default __webpack_public_path__ + "static/media/newsletter-element-2.7d63bde3b9550c9f60a0365328f67d45.svg";
export { ForwardRef as ReactComponent };